/*
*@/components/request/invite-new-providers
*/
export default {
  inviteNewProviders: {
    title: 'Invite new suppliers',
    steps: {
      title1: 'Suppliers',
      description1: 'Select the suppliers you are going to invite',
      title2: 'Item',
      description2: 'Select the item description',
      title3: 'Summary',
    },
    validation1: {
      label1: 'Supplier name',
      content1: 'You can enter the supplier name or select from suppliers already registered in CAT4MRO',
      placeholder1: 'Enter or select supplier name',
    },
    validation2: {
      label1: 'Supplier Rut ',
      placeholder1: 'Enter the Supplier Rut',
    },
    validation3: {
      label1: 'Contact Name',
      placeholder1: 'Enter the contact name',
    },
    validation4: {
      label1: 'Contact Email',
      placeholder1: 'Enter the contact email',
    },
    divider: 'Add supplier',
    table1: {
      column1: {
        p1: 'Contact Name:',
        p2: 'Contact Email:',
      },
      column2: {
        label1: 'Name',
      },
      column3: {
        label1: 'Rut',
      },
      column4: {
        label1: 'Registered',
        option1: 'Yes',
        option2: 'No',
      },
    },
    info_alert: 'No suppliers have been added yet',
    validation5: {
      content: 'Description that the supplier will use to identify the item you need',
      label: 'Item Description',
    },
    template1: {
      from: 'From:',
      to: 'To:',
      button: 'Suppliers',
      table: {
        column1: {
          p1: 'Contact Name:',
          p2: 'Contact Email:',
        },
        column2: {
          label: 'Name',
        },
        column3: {
          label: 'Rut',
        },
        column4: {
          label: 'Registered',
          span1: 'Yes',
          span2: 'No',
        },
      },
    },
    label: 'Item Description:',
    back_button: 'Back',
    forward_button: 'Next',
    loading_send: 'Sending requests...',
    send_requests: 'Send requests',
    script: {
      methods: {
        handleAddNewOrganization: {
          notify: {
            title: 'Add Supplier',
            message: 'This supplier is already invited to the information request.',
          },
        },
        handleSendRequests: {
          confirm: {
            title1: 'Are you sure you want to invite these suppliers?',
            title2: 'Warning',
            confirm_button: 'Yes, Send',
            cancel_button: 'No, Cancel',
            notify: {
              title: 'Information request',
              message: 'Information requests sent correctly',
            },
          },
          cancel: {
            notify: {
              title: 'Information request',
              message: 'The information request has not been sent.',
            },
          },
        },
        handleNextStep: {
          notify: {
            title: 'Select Suppliers',
            message: 'You must add at least one supplier to continue',
          },
        },
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/en-us/buyer/request_information/components/inviteNewProviders.js